import React, { useContext } from 'react';
import { Navigate } from 'react-router';

import { UserContext } from './context/UserContext';

const CustomerSuccessGuard = ({ children }) => {
  const { user } = useContext(UserContext);

  if (!user) return null;

  if (!user?.permissions?.superadmin && !user?.permissions?.customer_success) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default CustomerSuccessGuard;
